export default "__VITE_ASSET__BtalMGGg__"